import React from 'react';
import { useFormat } from 'helpers/hooks/useFormat';

const Secure = () => {
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });

  return (
    <div className="my-24 hidden border-b border-b-neutral-400 bg-neutral-200 py-24 text-center lg:block">
      <h1 className="text-36 uppercase">
        {formatCheckoutMessage({ id: 'secure.checkout', defaultMessage: 'Secure checkout' })}
      </h1>
    </div>
  );
};

export default Secure;
